import { getUserPermission } from "api/permission/getPermissions";
import { addPermissionIsUser } from "../actions/user";
import { setCompanyPermission } from "../actions/user";
import { setCoordinationOnly } from "../actions/user";
import { setPrimaryPackage } from "../actions/user";
import { setAllPermission } from "../actions/user";
import { getUserCompanyPermission } from "api/permission/getPermissions";
import { all_permissionsRef, company_permissionsRef, coordination_onlyRef, primary_packageRef, url, user_permissionsRef } from "api";

// Three attempts with a widening gap. A permission set is not optional
// and there is nothing sensible to do without it, so a transient failure
// is worth waiting out rather than degrading to "no access".
const fetchWithRetry = async (fn, attempts = 3) => {
  let lastErr = null;
  for (let i = 0; i < attempts; i++) {
    try {
      const res = await fn();
      // The API resolves error bodies too, so a payload without the
      // fields we came for counts as a failure worth retrying.
      if (res && (res.user_permissions || res.company_permissions || res.all_permissions)) return res;
      lastErr = new Error(res && res.err ? res.err : 'empty permission payload');
    } catch (err) {
      lastErr = err;
    }
    if (i < attempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, 600 * (i + 1)));
    }
  }
  console.log('initPermission: giving up after', attempts, 'attempts:', lastErr && lastErr.message);
  return null;
};

export const initPermission = async ({ Store, decoded }) => {
  if (
    localStorage.getItem(user_permissionsRef) &&
    localStorage.getItem(company_permissionsRef) &&
    localStorage.getItem(all_permissionsRef)
  ) {
    const user = localStorage.getItem(user_permissionsRef).split(",");
    const company = localStorage.getItem(company_permissionsRef).split(",");
    const all = localStorage.getItem(all_permissionsRef).split(",");

    Store.dispatch(addPermissionIsUser(user));
    Store.dispatch(setCompanyPermission(company));
    Store.dispatch(setAllPermission(all));
    Store.dispatch(
      setCoordinationOnly(localStorage.getItem(coordination_onlyRef) === "1")
    );
    Store.dispatch(
      setPrimaryPackage(localStorage.getItem(primary_packageRef) || "")
    );
  } else {
    // Retried, because losing this answer means losing access.
    //
    // Every permission-gated route - which is every coordination page -
    // only exists once this has landed. A single failed request left the
    // app with an empty permission set, and after the wait in App.jsx
    // expired the catch-all redirected the user to /authorization. So a
    // refresh during one bad response read as "you are not signed in",
    // on a session that was perfectly valid. The origin on this box
    // returns intermittent 5xx under load, which made that a routine
    // event rather than a rare one.
    const res = await fetchWithRetry(() => getUserCompanyPermission(decoded?.id, decoded?.company));
    if (res) {
      localStorage.setItem(user_permissionsRef, res?.user_permissions);
      localStorage.setItem(company_permissionsRef, res?.company_permissions);
      localStorage.setItem(all_permissionsRef, res?.all_permissions);
      localStorage.setItem(coordination_onlyRef, res?.coordination_only ? "1" : "0");
      localStorage.setItem(primary_packageRef, res?.primary_package || "");
      //
      Store.dispatch(addPermissionIsUser(res?.user_permissions));
      Store.dispatch(setCompanyPermission(res?.company_permissions));
      Store.dispatch(setAllPermission(res?.all_permissions));
      Store.dispatch(setCoordinationOnly(res?.coordination_only));
      Store.dispatch(setPrimaryPackage(res?.primary_package || ""));
    }
  }
};
